import http from './http'

export interface SpecificItem {
  content?: string
}

export interface PlanItem {
  name?: string
  value?: string
}

export interface ClauseItem {
  name?: string
  url?: string
}

export interface ShareDetail {
  shareCode: string
  productId: number
  productCode?: string
  productName?: string
  productSpecific?: string
  productPicUrl?: string
  providerId?: number
  providerName?: string
  premiumStart?: number | string
  premiumEnd?: number | string
  noticeText?: string
  salesUserName?: string
  bannerUrls?: string[]
  specifics?: SpecificItem[]
  insurancePlans?: PlanItem[]
  productInfoHtml?: string
  noticeHtml?: string
  liabilityHtml?: string
  clauses?: ClauseItem[]
}

export interface PreApplyForm {
  customerName: string
  customerIdType: string
  customerIdNo: string
  areaId: number
  areaName?: string
  customerContact: string
  customerMobile: string
  customerEmail?: string
  customerAddress?: string
  attachmentUrl?: string
  attachmentName?: string
  remark?: string
}

export interface PreApplyResult {
  success: boolean
  duplicated: boolean
  message?: string
}

export const getShareDetail = (shareCode: string) =>
  http.get(`/insurance/h5/share/${shareCode}`) as Promise<ShareDetail>

export const submitPreApply = (shareCode: string, data: PreApplyForm) =>
  http.post(`/insurance/h5/share/${shareCode}/pre-apply`, data) as Promise<PreApplyResult>

export const uploadPreApplyFile = (file: File) => {
  const data = new FormData()
  data.append('file', file)
  data.append('scene', 'insurance_h5_pre_apply_attachment')
  return http.post('/infra/file/upload', data) as Promise<string>
}
